import api from "@/lib/api";

// AI universal search — resolves ANY query typed in ANY search bar into an intent-aware route.
// Backend classifies (deterministic + Suffle AI): shop | travel | finance | service.
export async function resolveRoute(q) {
  const query = (q || "").trim();
  if (!query) return { kind: "shop", route: "/shop" };
  try {
    const r = await api.post("/marketplace/public/search-intent", { q: query });
    if (r.data?.route) return r.data;
  } catch { /* fall through to plain product search */ }
  return { kind: "shop", route: `/shop/search/${encodeURIComponent(query)}` };
}

// Convenience: resolve then navigate.
export async function goSmart(q, nav) {
  const query = (q || "").trim();
  if (!query) { nav("/shop"); return; }
  const { route } = await resolveRoute(query);
  nav(route || `/shop/search/${encodeURIComponent(query)}`);
}
